import { commonTranslations } from './common';
import { authTranslations } from './auth';
import { flashcardsTranslations } from './flashcards';
import { studyTranslations } from './study';
import { revisionSheetsTranslations } from './revisionSheets';
import { spacedRepetitionTranslations } from './spacedRepetition';
import { dashboardTranslations } from './dashboard';
import { chatTranslations } from './chat';
import { analyticsTranslations } from './analytics';
import { scheduleTranslations } from './schedule';
import { toastTranslations } from './toast';
import { scoresTranslations } from './scores';
import { communityTranslations } from './community';
import { checklistsTranslations } from './checklists';
import { calculatorTranslations } from './calculator';
import { medicationsTranslations } from './medications';
import { codingTranslations } from './coding';
import { guidelinesTranslations } from './guidelines';
import { rssTranslations } from './rss';
import { settingsTranslations } from './settings';
import { adminTranslations } from './admin';
import { adminPagesTranslations } from './adminPages';
import { dailyQuizTranslations } from './dailyQuiz';
import { quizTranslations } from './quiz';
import { consultationsTranslations } from './consultations';
import { voiceRecorderTranslations } from './voiceRecorder';
import { attachmentsTranslations } from './attachments';
import { coursesTranslations } from './courses';
import { landingTranslations } from './landing';
import { challengesTranslations } from './challenges';
import { hallOfFameTranslations } from './hallOfFame';
import { revisionExpressTranslations } from './revisionExpress';
import { statistiquesTranslations } from './statistiques';
import { subscribeTranslations } from './subscribe';
import { mobileNavTranslations } from './mobileNav';
import { sharedTranslations } from './shared';
import { urgentisteMasqueTranslations } from './urgentisteMasque';

type Lang = 'fr' | 'en' | 'es';

const buildLang = (lang: Lang) => ({
  common: commonTranslations[lang],
  auth: authTranslations[lang],
  flashcards: flashcardsTranslations[lang],
  study: studyTranslations[lang],
  revisionSheets: revisionSheetsTranslations[lang],
  spacedRepetition: spacedRepetitionTranslations[lang],
  dashboard: dashboardTranslations[lang],
  chat: chatTranslations[lang],
  analytics: analyticsTranslations[lang],
  schedule: scheduleTranslations[lang],
  toast: toastTranslations[lang],
  scores: scoresTranslations[lang],
  community: communityTranslations[lang],
  checklists: checklistsTranslations[lang],
  calculator: calculatorTranslations[lang],
  medications: medicationsTranslations[lang],
  coding: codingTranslations[lang],
  guidelines: guidelinesTranslations[lang],
  rss: rssTranslations[lang],
  settings: settingsTranslations[lang],
  admin: adminTranslations[lang],
  adminPages: adminPagesTranslations[lang],
  dailyQuiz: dailyQuizTranslations[lang],
  quiz: quizTranslations[lang],
  consultations: consultationsTranslations[lang],
  voiceRecorder: voiceRecorderTranslations[lang],
  attachments: attachmentsTranslations[lang],
  courses: coursesTranslations[lang],
  landing: landingTranslations[lang],
  challenges: challengesTranslations[lang],
  hallOfFame: hallOfFameTranslations[lang],
  revisionExpress: revisionExpressTranslations[lang],
  statistiques: statistiquesTranslations[lang],
  subscribe: subscribeTranslations[lang],
  mobileNav: mobileNavTranslations[lang],
  shared: sharedTranslations[lang],
  urgentisteMasque: urgentisteMasqueTranslations[lang],
});

/**
 * Get translations for a single language (used for lazy loading).
 */
export const getTranslationsForLang = (lang: Lang) => buildLang(lang);

/**
 * @deprecated Use getTranslationsForLang() for lazy loading instead.
 */
export const getAllTranslations = () => ({
  fr: { translation: buildLang('fr') },
  en: { translation: buildLang('en') },
  es: { translation: buildLang('es') },
});
